/*
  ATD - Collections 1
  Carrusel con scroll-snap nativo. Sin loop infinito.
  - Flechas prev/next (desktop): scroll por una card.
  - Barra de progreso (mobile): refleja la posición de scroll.
*/
(function () {
  const sections = document.querySelectorAll('.atd-collections1');
  if (!sections.length) return;

  sections.forEach((section) => {
    const track = section.querySelector('.atd-collections1__track');
    const prevBtn = section.querySelector('.atd-collections1__arrow--prev');
    const nextBtn = section.querySelector('.atd-collections1__arrow--next');
    const progressFill = section.querySelector('.atd-collections1__progress-fill');
    const progressWrap = section.querySelector('.atd-collections1__progress');
    if (!track) return;

    const getCards = () => track.querySelectorAll('.atd-collections1__card');
    const isOverflowing = () => track.scrollWidth > track.clientWidth + 1;

    const getStep = () => {
      const cards = getCards();
      if (cards.length < 2) return 0;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    };

    const scrollByCards = (delta) => {
      const step = getStep();
      if (step <= 0) return;
      track.scrollBy({ left: step * delta, behavior: 'smooth' });
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByCards(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByCards(1));

    const updateArrowState = () => {
      if (!prevBtn && !nextBtn) return;
      const max = track.scrollWidth - track.clientWidth;
      const pos = track.scrollLeft;
      if (prevBtn) prevBtn.toggleAttribute('disabled', pos <= 1);
      if (nextBtn) nextBtn.toggleAttribute('disabled', pos >= max - 1);
    };

    const updateProgress = () => {
      if (!progressFill || !progressWrap) return;
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) {
        progressWrap.style.display = 'none';
        return;
      }
      progressWrap.style.display = '';
      const pct = Math.min(1, Math.max(0, track.scrollLeft / max));
      progressFill.style.transform = `scaleX(${pct})`;
    };

    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        updateArrowState();
        updateProgress();
      });
    });

    const resync = () => {
      updateArrowState();
      updateProgress();
    };

    resync();
    window.addEventListener('resize', () => {
      clearTimeout(resync._t);
      resync._t = setTimeout(resync, 200);
    });
  });
})();
